<template>
  <div>
    <router-view v-show='this.$route.matched.length==3'></router-view>
    <PageHeaderLayout v-show='this.$route.matched.length==2'>
      <div class='main-page-content'>

        <!--        刊例列表-->
        <div class='plc-list'>
          <div style='padding: 10px 0;margin-bottom: 5px;'>
            <div class='theme-border flex-sb shadow-effect'
                 style='margin: auto;padding: 8px 50px 2px;border-radius: 50px'>
              <el-form :model='searchCondition' label-position='right' label-width='80px' inline>
                <el-form-item label=''>
                  <el-select
                    @change='handleQuery'
                    v-model='searchCondition.org_name'
                    filterable
                    allow-create
                    default-first-option
                    style='width: 120px'
                    placeholder='归属组织' clearable>
                    <el-option
                      v-for='item in options'
                      :key='item.value'
                      :label='item.label'
                      :value='item.value'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label=''>
                  <el-date-picker
                    v-model='searchCondition.year'
                    type='year'
                    format='yyyy 年'
                    value-format='yyyy'
                    style='width: 140px'
                    placeholder='请选择年份' @change='handleQuery' clearable>
                  </el-date-picker>
                </el-form-item>
                <el-form-item label=''>
                  <el-select
                    @change='handleQuery'
                    v-model='searchCondition.month'
                    filterable
                    style='width: 100px'
                    placeholder='月份' clearable>
                    <el-option
                      v-for='item in monthOptions'
                      :key='item.value'
                      :label='item.label'
                      :value='item.value'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input placeholder='刊例标题' v-model='searchCondition.title' @change='handleQuery'
                            clearable></el-input>
                </el-form-item>
                <el-form-item style='display: inline-block;float: right'>
                  <el-button icon='el-icon-search' type='primary' @click='handleQuery' round>查询</el-button>
                </el-form-item>
              </el-form>
              <div>
                <el-button type='primary' v-if="userPermissions.indexOf('plc_edit')>-1"
                           @click='handleAdd'>
                  <i class='el-icon-plus'></i> 新建
                </el-button>

                <el-button type='warning' v-if="userPermissions.indexOf('journal')>-1"
                           @click='handleSetUp'>
                  <i class='el-icon-setting'></i> 配置
                </el-button>
              </div>
            </div>

          </div>

          <el-table :data='dataList'
                    v-loading='loadingStatus'
                    element-loading-text='加载中……'
                    element-loading-spinner='el-icon-loading'
                    style='width: 100%;'
                    border
          >
            <el-table-column label='序号' align='center' width='55'>
              <template slot-scope='{$index,row}'>
                <span :title='`${row.id}`'> {{ offset + $index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label='组织' prop='org_name' align='center' width='88' />
            <el-table-column label='刊例月份' prop='year' align='center' width='100'>
              <template slot-scope='{row}'>
                <span>{{ row.year }}年{{ row.month }}月</span>
              </template>
            </el-table-column>
            <el-table-column label='刊例标题' align='center' min-width='200'
                             :show-overflow-tooltip='true' prop='title'>
              <template slot-scope='{row,column}'>
                <el-link v-if="userPermissions.indexOf('plc_detail')>-1" type='primary' @click='handleUpdate(row)'>
                  {{ row[column.property] || '/' }}
                </el-link>
                <span v-else>{{ row[column.property] || '/' }}</span>
                <span class='el-icon-copy-document' @click='handleCopyText(row[column.property])'
                      style='cursor: pointer;margin-left: 5px'></span>
              </template>
            </el-table-column>
            <el-table-column label='有效期' align='center' min-width='200'
                             :show-overflow-tooltip='true'>
              <template slot-scope='scope'>
                <span>{{ scope.row.validity_date || '/' }} ~ {{ scope.row.expiry_date || '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column label='提报截止日期' prop='deadline' align='center' width='140'></el-table-column>
            <el-table-column label='类型（平台）' prop='publications_count' align='center' width='120'>
              <template slot-scope='{row}'>
                <el-link v-if="userPermissions.indexOf('plc_detail')>-1" type='primary' @click='handleUpdate(row)'>
                  {{ row.publications_count || '/' }} 个
                </el-link>
                <span v-else>{{ row.publications_count || '/' }} 个</span>
              </template>
            </el-table-column>
            <el-table-column label='创建时间' prop='created_at' align='center' width='140'></el-table-column>
            <el-table-column label='修改时间' prop='updated_at' align='center' width='140'></el-table-column>
            <el-table-column label='#' width='130' align='center'>
              <template slot-scope='{row}'>
                <el-link v-if="userPermissions.indexOf('plc_save_quote')>-1" type='primary' @click='handleToPrice(row)'>
                  定价
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <m-pagination :limit.sync='pageData.page_size'
                          :page.sync='pageData.current_page'
                          :total.sync='pageData.total'
                          @pagination='getList' />

          </div>
        </div>

      </div>

      <el-dialog
        title='刊例类型配置'
        :visible.sync='dialogVisible'
        width='800px'
      >
        <Platforms-set-up></Platforms-set-up>
      </el-dialog>

      <!--      新建：模态框-->
      <PlcCreatePanel ref='refPlcCreatePanel' @saved='handleUpdate'></PlcCreatePanel>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { mapGetters } from 'vuex'
import ExportBtn from '@/components/export/ExportBtn'
import PlatformsSetUp from '@/pages/plc/setting/PlatformsSetUp'
import ChildPanel from '@/pages/plc/detail/ChildPanel'
import PlcCreatePanel from '@/pages/plc/PlcCreatePanel.vue'
import { copyTextToClipboard } from '@/utils/sys/copy'

export default {
  name: 'PlcIndex',
  components: { PlcCreatePanel, ChildPanel, PlatformsSetUp, ExportBtn, ApeTable, PageHeaderLayout },
  computed: {
    ...mapGetters(['userPermissions']),
    monthOptions() {
      return Array.from({ length: 12 }, (_, index) => {
        const month = index + 1
        return {
          label: `${month}月`,
          value: month.toString()
        }
      })
    }
  },
  data() {
    return {
      bgColor: '#8B0000',
      containerStyle: {
        background: '#8B0000'
      },
      isDarkTheme: true,
      loadingStatus: false,
      expandRowKey: null,
      searchCondition: { year: null, month: null, title: null, org_name: null },
      options: [],
      activeName: 'first',
      version: 2025,
      dataList: [],
      // 分页信息
      pageData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 15,
        current_page: 1
        // offset: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      dialogVisible: false,
      //筛选条件缓存key
      pageSearchKey: 'page_search_key:publication'
    }
  },
  watch: {
    '$route.matched': function(n) {
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    async init() {
      await this.loadOption()
      await this.getList()
    },
    handleCopyText(text) {
      copyTextToClipboard(text)
      this.$notify.success(`复制成功`)
    },
    /**
     * 记录当前展开页面
     * @param row
     */
    expandChange(row) {
      this.expandRowKey = row.id
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    handleAdd() {
      // this.$notify.info('新建刊例')
      // this.$router.push({ name: 'plc_create' })
      this.$refs['refPlcCreatePanel'].show()
    },
    handleUpdate(row) {
      // this.$notify.info('新建刊例')
      this.$router.push({ name: 'plc_edit', params: { id: row.id } })
    },
    handleToPrice(row) {
      this.$router.push({ name: 'plc_tpl_price_list', query: { pm_id: row.id } })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该月刊例, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.delPublicationMonthInfo(row.id)
        await this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    async loadOption() {
      // this.options = []
      let { options } = await this.$api.getPublicationOption()

      let arr = []
      options?.org_name.map((val) => {
        arr.push({ value: val, label: val })
      })

      this.options = arr
    },

    async getList() {
      this.loadingStatus = true
      let pagingInfo = { current_page: this.pageData.current_page, page_size: this.pageData.page_size }
      let searchCondition = this.handleSearchCondition()
      // 合并
      Object.assign(searchCondition, pagingInfo)
      let { list, pages } = await this.$api.getPublicationMonthList(searchCondition)
      this.$nextTick(() => {
        this.dataList = list
        let firstRowId = list[0] ? list[0]['id'] : ''
        let row = list.find((value) => value.id === this.expandRowKey)
        if (!row) {
          if (firstRowId) {
            this.expandRowKey = firstRowId
          }
        }
      })
      this.pageData.total = pages.total
      setTimeout(() => {
        this.loadingStatus = false
      }, 100)
    },

    handleSearchCondition() {
      let condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] != null) {
          if (Object.prototype.toString.call(this.searchCondition[field]) === '[object Array]') {
            if (this.searchCondition[field].length > 0) {
              condition[field] = this.searchCondition[field]
            }
          } else {
            // 字符串长度大于0
            if (this.searchCondition[field])
              condition[field] = this.searchCondition[field]
          }
        }
      })
      // 分页 +排序
      // Object.assign(condition, this.pageData, { orderBy: this.orderBy })

      return condition
    },
    handleSetUp() {
      this.dialogVisible = true
    }

  },
  mounted() {
    // console.log(this.$route.matched.length)
    if (this.$route.matched.length === 2) {
      this.init()
    }

  }
}
</script>

<style scoped>

/* 主页面样式 */
.main-page-content {
  background-image: url("https://tisu-prod.oss-cn-hangzhou.aliyuncs.com/www/assets/kols/banner.png") !important;
}

.main-page-content > *:not(.secondary-nav, button, .ape-drawer, .el-drawer) {
  width: clamp(1024px, 98%, 1920px);
  background: none !important; /* 移除所有背景设置 */
  border-radius: 10px;
  opacity: 0.96;
}

.plc-list {
  width: clamp(980px, 90%, 1440px) !important;
  margin: auto;
  padding: 10px;
}

.table-border {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* Vue 2: 使用 >>> 深度选择器 */
.table-no-background >>> .el-table,
.table-no-background >>> .el-table__header-wrapper,
.table-no-background >>> .el-table__body-wrapper {
  background: transparent !important;
}

.table-no-background >>> th,
.table-no-background >>> td,
.table-no-background >>> tr {
  background: transparent !important;
}

/* 移除斑马纹背景 */
.table-no-background >>> .el-table__row--striped td {
  background: transparent !important;
}

/* 移除悬停背景 */
.table-no-background >>> .el-table__row:hover td {
  background: transparent !important;
}


/* 使用 mix-blend-mode 实现自动反差的表格 */
.auto-contrast-table {
  isolation: isolate; /* 创建新的堆叠上下文 */
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

/* 表格整体使用混合模式 */
.auto-contrast-table >>> .el-table {
  mix-blend-mode: difference;
  background: transparent !important;
}

/* 表头 - 增强反差 */
.auto-contrast-table >>> .el-table__header th {
  color: white !important;
  background: rgba(255, 255, 255, 0.2) !important;
  mix-blend-mode: screen; /* 使表头在深色背景上更亮 */
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  border-bottom: 2px solid rgba(255, 255, 255, 0.3) !important;
}

/* 表体 - 使用 exclusion 获得更好的可读性 */
.auto-contrast-table >>> .el-table__body {
  mix-blend-mode: exclusion;
}

.auto-contrast-table >>> .el-table__body td {
  color: white !important;
  background: transparent !important;
  mix-blend-mode: difference;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* 行悬停效果 */
.auto-contrast-table >>> .el-table__row:hover td {
  mix-blend-mode: lighten;
  background: rgba(255, 255, 255, 0.15) !important;
  color: #FFFFFF !important;
}

.controls {
  margin-top: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(5px);
  mix-blend-mode: difference;
}
</style>

